module.exports = __webpack_public_path__ + "static/media/Create_discount_codes.2c19e8f4.svg";